export const arrow_right = () => (
  <path
    d="M5 12h14m0 0l-7-7m7 7l-7 7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
